export default class Laravel {

    protected accessTokenLocation: string
    protected googleDriveFolder: string
    protected googleDriveLocation: string
    protected oauthCredentials: object
    protected httpClient: any
    protected accessToken?: string

    protected googleDriveSurveyFolder: string
    protected apiKey: string
    protected googleUploadLocation: string
    protected ids: any
    protected cancelToken: any

    constructor(httpClient: any) {

        this.accessTokenLocation = process.env.VUE_APP_LARAVEL_API_ACCESS_TOKEN
        this.googleDriveFolder = process.env.VUE_APP_LARAVEL_API_GOOGLE_DRIVE_FOLDER
        this.googleDriveLocation = process.env.VUE_APP_LARAVEL_API_GOOGLE_DRIVE_LOCATION

        this.oauthCredentials = {
            'grant_type': process.env.VUE_APP_LARAVEL_API_GRANT_TYPE,
            'client_id': process.env.VUE_APP_LARAVEL_API_CLIENT_ID,
            'client_secret': process.env.VUE_APP_LARAVEL_API_CLIENT_SECRET,
            'username': process.env.VUE_APP_LARAVEL_API_ACCESS_USER_EMAIL,
            'password': process.env.VUE_APP_LARAVEL_API_ACCESS_USER_PASSWORD
        }

        this.httpClient = httpClient
        this.httpClient.defaults.baseURL = process.env.VUE_APP_LARAVEL_API_BASE_URL

        this.apiKey = process.env.VUE_APP_V3_API_KEY
        this.googleDriveSurveyFolder = process.env.VUE_APP_V3_SURVEY_FOLDER_ID
        // this.googleDriveSurveyFolder = process.env.VUE_APP_V3_CCTV_UPLOAD_ID
        this.googleUploadLocation = process.env.VUE_APP_V3_CCTV_UPLOAD_LOCATION
    }

    protected createLaravelAccessToken() {

        return this.httpClient.request({
                url: this.accessTokenLocation,
                method: 'post',
                data: this.oauthCredentials
            })
            .then((response: any) => this.accessToken = response.data.access_token)
    }

    protected setClientIds(customerCode: any, customerEmail: any, cancelToken: any, refNo: any, surveyNo: any) {
        this.cancelToken = cancelToken;
        return this.httpClient.put(this.googleDriveSurveyFolder, {
                code: customerCode,
                email: customerEmail,
                refNo: refNo,
                surveyNo: surveyNo
            }, 
            {
                headers: {
                    Authorization: this.apiKey
                },
                cancelToken: this.cancelToken
            })
            .then((response: any) => {
                this.ids = response.data;
                return response.data;
            })
    }
}